"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reset = exports.passwordResetFinish = void 0;
var password_reset_1 = require("@pbl/pbl-react-core/lib/models/password-reset");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var action_type_util_1 = require("../../action-type.util");
var actions_1 = require("../app/actions");
var passwordResetFinish = function (key, newPassword) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_1, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, 3, 4]);
                if (!key || key.length === 0) {
                    dispatch((0, actions_1.showMessageBar)({
                        message: 'password.reset',
                        type: 'error',
                        messageTimeout: 6000
                    }));
                    return [2];
                }
                dispatch((0, actions_1.toggleLoading)({ spinning: true }));
                return [4, services_1.AccountService.passwordReset(key, newPassword)];
            case 1:
                _a.sent();
                dispatch({ type: (0, action_type_util_1.SUCCESS)(password_reset_1.RESET_PASSWORD_FINISH) });
                return [3, 4];
            case 2:
                e_1 = _a.sent();
                if (e_1.payload && e_1.payload.errorKey) {
                    message = e_1.payload.errorKey;
                    switch (message) {
                        case 'error.usernotfound':
                            dispatch(showErrorMessage('Password reset key is invalid.'));
                            break;
                        case 'error.expiredKey':
                            dispatch(showErrorMessage('Password reset key has expired.'));
                            break;
                        case 'error.uaaUser.registerLockout':
                            dispatch(showErrorMessage('account.locked'));
                            break;
                        case 'error.uaaUser.registerSuspended':
                            dispatch(showErrorMessage('account.suspended'));
                            break;
                        case 'error.uaaUser.resetPasswordLockout':
                            dispatch(showErrorMessage('account.locked'));
                            break;
                        case 'error.uaaUser.resetPasswordSuspended':
                            dispatch(showErrorMessage('account.suspended'));
                            break;
                        case 'error.email.notfound':
                            dispatch(showErrorMessage('account.emailNotFound'));
                            break;
                        default:
                            dispatch(showErrorMessage(e_1.payload.title ? e_1.payload.title : 'error.general'));
                            break;
                    }
                }
                return [3, 4];
            case 3:
                dispatch((0, actions_1.toggleLoading)({ spinning: false }));
                return [7];
            case 4: return [2];
        }
    });
}); }; };
exports.passwordResetFinish = passwordResetFinish;
var showErrorMessage = function (message) {
    return (0, actions_1.showMessageBar)({
        message: message,
        type: 'error'
    });
};
var reset = function () { return ({
    type: password_reset_1.RESET_PASSWORD_STATE
}); };
exports.reset = reset;
//# sourceMappingURL=actions.js.map